module.exports = __webpack_public_path__ + "static/starsfull-5294ad256d3e5f8fad10ba3ad1bccb88.svg";